let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("ikh28")).then(() => parcelRequire('1BNgi'));